/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { MRT_ColumnDef, MRT_PaginationState } from 'mantine-react-table'
import { FieldType } from 'src/interfaces'
import TableComponent from 'src/components/TableComponent'
import dayjs from 'dayjs'
import { formatDateTime, size } from 'src/variable/constant'
import { getUserDevices } from 'src/apis/userAPI'
import CustomTooltip from '../CustomComponents/CustomTooltip'
import { formatTimeNumber } from 'src/utils/utils'
import { Circle, Sort } from '@mui/icons-material'
import { Stack } from '@mui/material'
import { Flex } from '@mantine/core'

export interface DeviceItemType {
    id: string;
    user_id: string;
    deviceId: string;
    brand: string;
    deviceModel: string;
    device_name: string;
    platform: string;
    version: string;
    last_login_at: string; 
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
  }

const fields: FieldType[] = [
    {
        value: 'last_login_at',
        label: 'Device Model',
    },
    {
        value: 'device_model',
        label: 'Device Model',
    },
    {
        value: 'device_id',
        label: 'deviceId',
    },
    {
        value: 'platform',
        label: 'Platform',
    },
    {
        value: 'version',
        label: 'version',
    },
]

interface ListDeviceProps {
    userId: string
}


function ListDevice({ userId }: ListDeviceProps) {


    const columns: MRT_ColumnDef[] = [
        {
            accessorKey: 'no',
            header: 'No',
            size: size.zero,
        },
        {
            accessorKey: 'platform',
            header: 'Platform',
            size: size.zero,
            maxSize: size.text,
            Header: () => <>
                <CustomTooltip label="Platform" maxWidth={size.text} />
                <Sort onClick={() => handleChangeSort('platform')} />
                </>,
            Cell: ({ cell }) => {
                return (
                    <CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
                )
            },
        },
        {
            accessorKey: 'device_model',
            header: 'Device Model',
            size: size.zero,
            maxSize: size.text,
            Header: () => <>
                <CustomTooltip label="Device Model" maxWidth={size.text} />
                <Sort onClick={() => handleChangeSort('device_model')} />
                </>,
    
            Cell: ({ cell, row }) => {
                const isActive = row.original['deleted_at'] === null ? true : false
                return (
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Circle color={isActive ? 'success' : 'error'} sx={{ fontSize: 12 }} />
                        <CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
                    </Stack>
                )
            },
            
        },
        {
            accessorKey: 'device_id',
            header: 'Device Id',
            size: size.zero,
            maxSize: size.text,
            Cell: ({ cell }) => {
                return (
                    <CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
                )
            },
        },
        {
            accessorKey: 'version',
            header: 'Version',
            size: size.zero,
            maxSize: size.text,
            Cell: ({ cell }) => {
                return (
                    <CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
                )
            },
        },
        {
            accessorKey: 'created_at',
            header: 'First login',
            size: size.zero,
            maxSize: size.text,
            Header: () => <>
                <CustomTooltip label="First login" maxWidth={size.text} />
                <Sort onClick={() => handleChangeSort('created_at')} />
                </>,
        },
        {
            accessorKey: 'last_login_at',
            header: 'Last login',
            size: size.zero,
            maxSize: size.text,
            Cell: ({ cell }) => {
                return (
                    <>
                        {cell ? <CustomTooltip label={formatTimeNumber(Number(cell.getValue<number>()))} maxWidth={size.text} /> : ''}
                    </>
                )
            }
        },
    ]
    const [data, setData] = useState<DeviceItemType[]>([])
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 1,
        pageSize: 10,
    })
    const [value, setValue] = useState<{field: string, order: { [key: string]: 'asc' | 'desc' }[]}>({
        field: fields[0].value,
        order: [{
            last_login_at: 'asc',
        }
    ],
    })
    const [total, setTotal] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false)

    const handleGetData = useCallback(async () => {
        let arr: DeviceItemType[] = []
        let count: number = 0
        setLoading(true)
        try {
            const res = await getUserDevices(userId, {
                fields: ['$all'],
                order: value.order,
                page: pagination.pageIndex,
                limit: pagination.pageSize,
            })
            
            arr = res?.data?.results?.objects?.rows?.map((item, index) => ({
                no: index + 1 + pagination.pageSize * (pagination.pageIndex - 1),
                ...item,
                created_at: dayjs(item?.created_at).format(formatDateTime),
            }))

            count = res?.data?.results?.objects?.count
        } catch (error) {
            console.log('error:', error);
            
        } finally {
            setData(arr)
            setTotal(count)

            setTimeout(() => {
                setLoading(false)
            }, 500)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(pagination), JSON.stringify(value)])

    const handleChangePage = useCallback((value: number) => {
        setPagination((pre) => ({
            ...pre,
            pageIndex: value,
        }))
    }, [])
    
    const handleChangeSort = (field: string) => {
        if (value.order[field] && value.order[field] === 'asc') {
            setValue((pre) => ({ ...pre, order: [...pre.order, { [field]: 'desc' }] }));
            
        } else {
            setValue((pre) => ({ ...pre, order: [...pre.order, { [field]: 'asc' }] }));
        }
    }


    useEffect(() => {
        handleGetData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
        console.log(value.order);
        
    }, [JSON.stringify(pagination), value.order])

    return (
        <Stack sx={{ width: '100%' }}>
            <Flex gap={8} justify="space-between" sx={{ flexWrap: 'wrap' }}>
                <Flex gap={8} sx={{ flexWrap: 'wrap' }}>
                    <div style={{ fontWeight: 700 }}>Devices:</div>
                </Flex>

                <TableComponent
                    enableRowActions={false}
                    columns={columns}
                    total={total}
                    data={data}
                    pagination={pagination}
                    loading={loading}
                    handleChangePage={handleChangePage}
                    />
            </Flex>
        </Stack>
    )
}

export default ListDevice
